export const VENDOR_LIST = "CASINO_VENDOR_LIST";
export const CASINO_GAME_ACCESS = "CASINO_GAME_ACCESS";